import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';


@Component({
  selector: 'app-process-list-unarchive-dialog',
  templateUrl: './process-list-unarchive-dialog.component.html',
  styleUrls: ['./process-list-unarchive-dialog.component.scss']
})
export class ProcessListUnarchiveDialogComponent implements OnInit {

  form: FormGroup;
  submitting: boolean = false;
  process: any[] = [];

  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private snackbar : MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<ProcessListUnarchiveDialogComponent>

  ) {

    this.form = this.fb.group({
      selectedProcesses: [[], Validators.required]
    });

  }

  ngOnInit(): void {
    this.getProcessList();
  }

  submit(){
    
    const selectedProcessIds = JSON.stringify(this.form.value.selectedProcesses);
    const isValid = !this.form.invalid;
    
    if (isValid) {
        if(selectedProcessIds){
        this.http.save('process_list:unarchive', { process_id: selectedProcessIds })
        .subscribe(
          (result: any) => {
            if(result.type === 'OK') {
              this.snackbar.open('Os Processos Seletivos foram Desarquivados!', 'OK', { duration: 3000 });
              this.dialogRef.close(result);
            } else {
              this.snackbar.open('Desculpe, ocorreu um erro. Tente novamente mais tarde!', 'OK', { duration: 3000 });
            }
          },
          err => this.errorReport.showMessage(err)
        )
      }
    }
    
  }

  getProcessList() {
    const user = JSON.parse(localStorage.getItem('token'));
    this.http.save('process_list:get-archived', { id: user.company_id })
      .subscribe(
        (result: any) => {
          this.process = result.data;
        },
        err => this.errorReport.showMessage(err)
    )
  }

  formatMoney(valor): void {
    let value = valor

    // Remover qualquer formatação existente
    value = value.replace(/\D/g, '');

    // Adicionar vírgula após o terceiro caractere
    if (value.length > 3) {
      const beforeDecimal = value.slice(0, -2);
      const afterDecimal = value.slice(-2);
      value = beforeDecimal + ',' + afterDecimal;
    }

    // Formatar o valor inserindo o ponto como separador de milhares
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Atualizar o valor no campo de entrada
    return value;
  }

}
